import { render, staticRenderFns } from "./MnemonicsViewer.vue?vue&type=template&id=65957810&scoped=true&"
import script from "./MnemonicsViewer.vue?vue&type=script&lang=js&"
export * from "./MnemonicsViewer.vue?vue&type=script&lang=js&"
import style0 from "./MnemonicsViewer.vue?vue&type=style&index=0&id=65957810&prod&scoped=true&lang=css&"
import style1 from "./MnemonicsViewer.vue?vue&type=style&index=1&id=65957810&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65957810",
  null
  
)

export default component.exports